module.exports = __webpack_public_path__ + "static/120_years_of_nanosilver_history-e29335f48c9efdb6d02ba352e52b06df.pdf";